import React, { FC } from 'react';

interface Props {
  title: string;
  children: React.ReactNode;
  viewBox: string;
  width?: string;
  height?: string;
  className?: string;
  preserveAspectRatio?: string;
}

const Svg: FC<Props> = ({
  children,
  className,
  height = '100%',
  preserveAspectRatio,
  title,
  viewBox,
  width = '100%',
}) => {
  return (
    <svg
      className={className}
      height={height}
      preserveAspectRatio={preserveAspectRatio}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      {children}
    </svg>
  );
};

export default React.memo(Svg);
